import { render, staticRenderFns } from "./StBaseComp.vue?vue&type=template&id=7589efe4&"
import script from "./StBaseComp.vue?vue&type=script&lang=js&"
export * from "./StBaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports